'use client';

import { c as _c } from "react/compiler-runtime";
import BreadCrumbs from '@components/breadcrumbs/BreadCrumbs';
import ROUTES from '@lib/constants/routes';
import { groupByQueue } from '@lib/tools/_group_gallery_by_queue';
import useMousePosition from '@lib/tools/hooks/useMousePosition';
import cn from 'classnames';
import { useEffect, useState } from 'react';
import SwiperCore from 'swiper';
import { FreeMode, Mousewheel } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/effect-creative';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import { GalleryFilterCategories } from '../gallery-filter-categories/GalleryFilterCategories';
import GallerySlideInner from '../gallery-slide-inner/GallerySlideInner';
import GallerySliderModal from '../gallery-slider-modal/GallerySliderModal';
import style from './GallerySlider.module.scss';
SwiperCore.use([FreeMode, Mousewheel]);
const breadCrumbsApi = {
  crumbs: [{
    id: 1,
    text: 'Главная',
    link: ROUTES.root
  }, {
    id: 2,
    text: 'Галерея'
  }]
};
const GallerySlider = t0 => {
  const $ = _c(104);
  const {
    gallery
  } = t0;
  const [scale, setScale] = useState(1);
  const [swiper, setSwiper] = useState(null);
  const [modalStatus, setModalStatus] = useState(false);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = [];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const [categories, setCategories] = useState(t1);
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {};
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const [groupCategories, setGroupCategories] = useState(t2);
  const [queue, setQueue] = useState(null);
  const [swiperActive, setSwiperActive] = useState(0);
  const [activeSwitch, setActiveSwitch] = useState(null);
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = [];
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const [sliderArr, setSliderArr] = useState(t3);
  const [selector, setSelector] = useState(false);
  const [currUrl, setCurrUrl] = useState("");
  const [element, setElement] = useState(null);
  const [cursorStatus, setCursorStatus] = useState(false);
  const {
    x,
    y
  } = useMousePosition();
  let t4;
  let t5;
  if ($[3] !== element) {
    t4 = () => {
      setScale(element?.getBoundingClientRect().width / element?.offsetWidth);
    };
    t5 = [element];
    $[3] = element;
    $[4] = t4;
    $[5] = t5;
  } else {
    t4 = $[4];
    t5 = $[5];
  }
  useEffect(t4, t5);
  let t6;
  if ($[6] !== swiper || $[7] !== swiperActive) {
    t6 = () => {
      swiper.slideTo(swiperActive - 1);
    };
    $[6] = swiper;
    $[7] = swiperActive;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  const handlePrev = t6;
  let t7;
  if ($[9] !== swiper) {
    t7 = () => {
      swiper.slideNext();
    };
    $[9] = swiper;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  const handleNext = t7;
  let t8;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = () => {
      setModalStatus(true);
    };
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  const handleOnClick = t8;
  swiper?.on("slideChange", () => {
    setSwiperActive(swiper.activeIndex);
  });
  let t10;
  let t9;
  if ($[12] !== gallery) {
    t9 = () => {
      if (gallery) {
        setActiveSwitch(gallery[0]?.title);
        const grouped = groupByQueue(gallery) || {};
        setQueue(Object.keys(grouped)?.[0]);
        setGroupCategories(grouped);
        const uniqueTitles = new Set(gallery.map(_temp));
        setCategories(Array.from(uniqueTitles));
      }
    };
    t10 = [gallery];
    $[12] = gallery;
    $[13] = t10;
    $[14] = t9;
  } else {
    t10 = $[13];
    t9 = $[14];
  }
  useEffect(t9, t10);
  let t11;
  if ($[15] !== activeSwitch || $[16] !== gallery || $[17] !== queue) {
    t11 = () => {
      if (gallery && activeSwitch) {
        const sliderItem = gallery.find(i => i.title === activeSwitch && i.queue === queue);
        if (sliderItem) {
          setSliderArr(sliderItem.absolutePath);
        }
      }
    };
    $[15] = activeSwitch;
    $[16] = gallery;
    $[17] = queue;
    $[18] = t11;
  } else {
    t11 = $[18];
  }
  let t12;
  if ($[19] !== activeSwitch || $[20] !== gallery || $[21] !== queue || $[22] !== sliderArr) {
    t12 = [activeSwitch, gallery, queue, sliderArr];
    $[19] = activeSwitch;
    $[20] = gallery;
    $[21] = queue;
    $[22] = sliderArr;
    $[23] = t12;
  } else {
    t12 = $[23];
  }
  useEffect(t11, t12);
  let t13;
  if ($[24] !== swiper) {
    t13 = () => {
      if (swiper) {
        setTimeout(() => {
          swiper.slideTo(0);
        }, [500]);
      }
    };
    $[24] = swiper;
    $[25] = t13;
  } else {
    t13 = $[25];
  }
  let t14;
  if ($[26] !== activeSwitch || $[27] !== swiper) {
    t14 = [activeSwitch, swiper];
    $[26] = activeSwitch;
    $[27] = swiper;
    $[28] = t14;
  } else {
    t14 = $[28];
  }
  useEffect(t13, t14);
  let t15;
  let t16;
  if ($[29] !== swiper || $[30] !== swiperActive) {
    t15 = () => {
      if (swiper) {
        swiper.slideTo(swiperActive);
      }
    };
    t16 = [swiperActive, swiper];
    $[29] = swiper;
    $[30] = swiperActive;
    $[31] = t15;
    $[32] = t16;
  } else {
    t15 = $[31];
    t16 = $[32];
  }
  useEffect(t15, t16);
  let t17;
  if ($[33] !== sliderArr || $[34] !== swiperActive) {
    t17 = () => {
      setCurrUrl(sliderArr[swiperActive]);
    };
    $[33] = sliderArr;
    $[34] = swiperActive;
    $[35] = t17;
  } else {
    t17 = $[35];
  }
  let t18;
  if ($[36] !== modalStatus || $[37] !== sliderArr || $[38] !== swiperActive) {
    t18 = [sliderArr, swiperActive, modalStatus];
    $[36] = modalStatus;
    $[37] = sliderArr;
    $[38] = swiperActive;
    $[39] = t18;
  } else {
    t18 = $[39];
  }
  useEffect(t17, t18);
  let t19;
  let t20;
  if ($[40] !== currUrl) {
    t19 = () => {
      setElement(document.getElementById(currUrl));
    };
    t20 = [currUrl];
    $[40] = currUrl;
    $[41] = t19;
    $[42] = t20;
  } else {
    t19 = $[41];
    t20 = $[42];
  }
  useEffect(t19, t20);
  let t21;
  if ($[43] === Symbol.for("react.memo_cache_sentinel")) {
    t21 = [];
    $[43] = t21;
  } else {
    t21 = $[43];
  }
  useEffect(_temp3, t21);
  let t22;
  if ($[44] === Symbol.for("react.memo_cache_sentinel")) {
    t22 = <div className={style.crumbs}><BreadCrumbs item={breadCrumbsApi} /></div>;
    $[44] = t22;
  } else {
    t22 = $[44];
  }
  let t23;
  let t24;
  if ($[45] === Symbol.for("react.memo_cache_sentinel")) {
    t23 = {
      enabled: true,
      sensitivity: 4
    };
    t24 = {
      enabled: true,
      sticky: false,
      momentumBounce: false
    };
    $[45] = t23;
    $[46] = t24;
  } else {
    t23 = $[45];
    t24 = $[46];
  }
  let t25;
  if ($[47] !== cursorStatus || $[48] !== x || $[49] !== y) {
    t25 = cursorStatus === true && <div className={style.cursorImg} style={{
      left: x,
      top: y
    }}><svg width="86" height="86" viewBox="0 0 86 86" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="43" cy="43" r="41.82" stroke="white" strokeWidth="1.36" /><path d="M37.9 43.5663H49.2334" stroke="white" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" /><path d="M43.5667 49.2329V37.8996" stroke="white" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" /></svg></div>;
    $[47] = cursorStatus;
    $[48] = x;
    $[49] = y;
    $[50] = t25;
  } else {
    t25 = $[50];
  }
  let t26;
  if ($[51] !== sliderArr || $[52] !== swiper) {
    t26 = sliderArr?.map(url => <SwiperSlide key={url} className={style.swiperSlide} onMouseOver={() => setCursorStatus(true)} onMouseOut={() => setCursorStatus(false)} onClick={handleOnClick}><GallerySlideInner url={url} swiper={swiper} /></SwiperSlide>);
    $[51] = sliderArr;
    $[52] = swiper;
    $[53] = t26;
  } else {
    t26 = $[53];
  }
  let t27;
  if ($[54] === Symbol.for("react.memo_cache_sentinel")) {
    t27 = () => setSelector(_temp4);
    $[54] = t27;
  } else {
    t27 = $[54];
  }
  let t28;
  if ($[55] !== queue) {
    t28 = queue && <span>{queue} • </span>;
    $[55] = queue;
    $[56] = t28;
  } else {
    t28 = $[56];
  }
  let t29;
  if ($[57] !== selector) {
    t29 = cn(style.selector__arrow, {
      [style.selector__arrow_down]: selector
    });
    $[57] = selector;
    $[58] = t29;
  } else {
    t29 = $[58];
  }
  let t30;
  if ($[59] === Symbol.for("react.memo_cache_sentinel")) {
    t30 = <path d="M7.75 7.21238e-07L0.605289 6.75L14.8947 6.75L7.75 7.21238e-07Z" fill="#1C1C1C" />;
    $[59] = t30;
  } else {
    t30 = $[59];
  }
  let t31;
  if ($[60] !== t29) {
    t31 = <svg className={t29} width="15" height="7" viewBox="0 0 15 7" fill="none" xmlns="http://www.w3.org/2000/svg">{t30}</svg>;
    $[60] = t29;
    $[61] = t31;
  } else {
    t31 = $[61];
  }
  let t32;
  if ($[62] !== activeSwitch || $[63] !== t28 || $[64] !== t31) {
    t32 = <button className={style.selector__active} onClick={t27}>{t28}{activeSwitch}{t31}</button>;
    $[62] = activeSwitch;
    $[63] = t28;
    $[64] = t31;
    $[65] = t32;
  } else {
    t32 = $[65];
  }
  let t33;
  if ($[66] !== activeSwitch || $[67] !== categories || $[68] !== groupCategories || $[69] !== queue || $[70] !== selector) {
    t33 = selector && <div className={style.selector__list}><GalleryFilterCategories queue={queue} setQueue={setQueue} groupCategories={groupCategories} categories={categories} activeSwitch={activeSwitch} setActiveSwitch={setActiveSwitch} /></div>;
    $[66] = activeSwitch;
    $[67] = categories;
    $[68] = groupCategories;
    $[69] = queue;
    $[70] = selector;
    $[71] = t33;
  } else {
    t33 = $[71];
  }
  let t34;
  if ($[72] !== t32 || $[73] !== t33) {
    t34 = <div className={style.selector}>{t32}{t33}</div>;
    $[72] = t32;
    $[73] = t33;
    $[74] = t34;
  } else {
    t34 = $[74];
  }
  let t35;
  if ($[75] === Symbol.for("react.memo_cache_sentinel")) {
    t35 = <svg width="15" height="12" viewBox="0 0 15 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.876367 6.49105C0.605168 6.21985 0.605168 5.78015 0.876367 5.50895L5.29578 1.08954C5.56698 0.81834 6.00668 0.81834 6.27788 1.08954C6.54907 1.36073 6.54907 1.80043 6.27788 2.07163L2.34951 6L6.27788 9.92837C6.54907 10.1996 6.54907 10.6393 6.27788 10.9105C6.00668 11.1817 5.56698 11.1817 5.29578 10.9105L0.876367 6.49105ZM14.9443 6.69444L1.36741 6.69445L1.36741 5.30556L14.9443 5.30556L14.9443 6.69444Z" fill="#1C1C1C" /></svg>;
    $[75] = t35;
  } else {
    t35 = $[75];
  }
  let t36;
  if ($[76] !== handlePrev) {
    t36 = <div className="swiper-button-prev gallery_swiper__prev" onClick={handlePrev} role="button" tabIndex="0">{t35}</div>;
    $[76] = handlePrev;
    $[77] = t36;
  } else {
    t36 = $[77];
  }
  let t37;
  if ($[78] === Symbol.for("react.memo_cache_sentinel")) {
    t37 = <div className="swiper-pagination swiper-pagination-fraction swiper-pagination-horizontal" />;
    $[78] = t37;
  } else {
    t37 = $[78];
  }
  const t38 = swiperActive + 1;
  let t39;
  if ($[79] !== sliderArr.length || $[80] !== t38) {
    t39 = <div className={style.nav__counter}>{t38}/{sliderArr.length}</div>;
    $[79] = sliderArr.length;
    $[80] = t38;
    $[81] = t39;
  } else {
    t39 = $[81];
  }
  let t40;
  if ($[82] === Symbol.for("react.memo_cache_sentinel")) {
    t40 = <svg width="15" height="12" viewBox="0 0 15 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M14.1236 6.49105C14.3948 6.21985 14.3948 5.78015 14.1236 5.50895L9.70422 1.08954C9.43302 0.81834 8.99332 0.81834 8.72212 1.08954C8.45093 1.36073 8.45093 1.80043 8.72212 2.07163L12.6505 6L8.72212 9.92837C8.45093 10.1996 8.45093 10.6393 8.72212 10.9105C8.99332 11.1817 9.43302 11.1817 9.70422 10.9105L14.1236 6.49105ZM0.055664 6.69444L13.6326 6.69445L13.6326 5.30556L0.0556641 5.30556L0.055664 6.69444Z" fill="#1C1C1C" /></svg>;
    $[82] = t40;
  } else {
    t40 = $[82];
  }
  let t41;
  if ($[83] !== handleNext) {
    t41 = <div className="swiper-button-next gallery_swiper__next" onClick={handleNext} role="button" tabIndex="0">{t40}</div>;
    $[83] = handleNext;
    $[84] = t41;
  } else {
    t41 = $[84];
  }
  let t42;
  if ($[85] !== t34 || $[86] !== t36 || $[87] !== t39 || $[88] !== t41) {
    t42 = <div className={style.nav}>{t34}{t36}{t37}{t39}{t41}</div>;
    $[85] = t34;
    $[86] = t36;
    $[87] = t39;
    $[88] = t41;
    $[89] = t42;
  } else {
    t42 = $[89];
  }
  let t43;
  if ($[90] !== t25 || $[91] !== t26 || $[92] !== t42) {
    t43 = <div className={style.content}>{t22}<Swiper onSwiper={setSwiper} slidesPerView="auto" mousewheel={t23} freeMode={t24} className={`gallery_swiper ${style.swiper}`}>{t25}{t26}{t42}</Swiper></div>;
    $[90] = t25;
    $[91] = t26;
    $[92] = t42;
    $[93] = t43;
  } else {
    t43 = $[93];
  }
  let t44;
  if ($[94] !== activeSwitch || $[95] !== categories || $[96] !== modalStatus || $[97] !== scale || $[98] !== sliderArr || $[99] !== swiperActive) {
    t44 = <GallerySliderModal categories={categories} swiperActive={swiperActive} setSwiperActive={setSwiperActive} activeSwitch={activeSwitch} setActiveSwitch={setActiveSwitch} sliderArr={sliderArr} modalStatus={modalStatus} setModalStatus={setModalStatus} scale={scale} setScale={setScale} />;
    $[94] = activeSwitch;
    $[95] = categories;
    $[96] = modalStatus;
    $[97] = scale;
    $[98] = sliderArr;
    $[99] = swiperActive;
    $[100] = t44;
  } else {
    t44 = $[100];
  }
  let t45;
  if ($[101] !== t43 || $[102] !== t44) {
    t45 = <>{t43}{t44}</>;
    $[101] = t43;
    $[102] = t44;
    $[103] = t45;
  } else {
    t45 = $[103];
  }
  return t45;
};
export default GallerySlider;
function _temp(item) {
  return item.title;
}
function _temp2(event) {
  if ((event.ctrlKey || event.metaKey) && (event.keyCode === 187 || event.keyCode === 107)) {
    event.preventDefault();
  }
  if ((event.ctrlKey || event.metaKey) && (event.keyCode === 189 || event.keyCode === 109)) {
    event.preventDefault();
  }
}
function _temp3() {
  const handleKeyDown = _temp2;
  window.addEventListener("keydown", handleKeyDown);
  return () => window.removeEventListener("keydown", handleKeyDown);
}
function _temp4(prev) {
  return !prev;
}